<div class="alert-box info" *ngIf="alertType==alertTypes.info">

    <div class="content">
        <i class="fal fa-bell"></i>
        <div class="c" *ngIf="title">{{title | translate}}</div>
        <div class="alert-body" [translate]="body" [translateParams]="translatedValues">

        </div>
    </div>
    <div class="action" *ngIf="hasButton">
        <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
    </div>
</div>

<div class="alert-box error" *ngIf="alertType==alertTypes.error">
    <div class="content">
        <i class="fal fa-circle-exclamation"></i>
        <div>
            <div class="title" *ngIf="title">{{title | translate}}</div>
            <div class="alert-body" [translate]="body" [translateParams]="translatedValues">
                <!-- {{body | translate}} -->
            </div>
        </div>
    </div>


    <div class="action" *ngIf="hasButton">
        <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
    </div>

</div>

<div class="alert-box warning {{icon? 'orange':''}}" *ngIf="alertType==alertTypes.warning">
    <div class="content">
        <i class=" {{icon ? icon:'fal fa-hourglass-empty'}}"></i>
        <div>
            <div class="title" *ngIf="title">{{title | translate}}</div>
            <div class="alert-body" [translate]="body"  [translateParams]="translatedValues">
               
            </div>
            <div class="alert-body second-body" *ngIf="secondBody" [translate]="secondBody" [translateParams]="translatedValues">
                <!-- {{body | translate}} -->
            </div>
        </div>
    </div>
    <div class="action" *ngIf="hasButton">
        <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
    </div>

</div>

<div class="alert-box data-verify" *ngIf="personalInfoVerified">
    <div class="content">
        <i class="fal fa-circle-exclamation"></i>
        <div>
            <div class="title">{{'MG_GENERAL.VERIFY_PERSONAL_DATA_TITLE' | translate}}</div>
           <a class="link" href="/profile">{{'MG_GENERAL.VERIFY_PERSONAL_DATA_LINK' | translate}}</a>
        </div>
    </div>
    </div>

<div class="alert-box alarm" *ngIf="alertType==alertTypes.alarm">
    <div class="content">
        <i class="fal fa-triangle-exclamation"></i>
        <div>
            <div class="title" *ngIf="title">{{title | translate}}</div>
            <div class="alert-body">
                {{body | translate}}
            </div>
        </div>
    </div>

    <div class="action" *ngIf="hasButton">
        <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
    </div>

</div>

<ng-template #buttonContent>
    <ng-content></ng-content>
</ng-template>